<template>
  <div class="exhibitionRecord">
    <el-col class="userinfoList infoPub" style="width: 990px">
      <div class="exhContent">
        <!-- 搜索组件 -->
        <search-bar
          :selectType="ExhIndexType"
          :searchInputPlc="searchInputPlc"
          :searchSelectPlc="searchSelectPlc"
          :orderManage="true"
          @changeExhibitionState="toSearch"
          @toSearch="toSearch"
        ></search-bar>
        <!--提示信息-->
<!--        <div class="prompt-info-wrap">-->
<!--          <div-->
<!--            class="prompt-info"-->
<!--            v-if="lan == 'ch'"-->
<!--            style="padding-top:15px;margin-top:10px;"-->
<!--          >-->
<!--            1、观展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。-->
<!--          </div>-->
<!--          <div-->
<!--            class="prompt-info"-->
<!--            style="padding-bottom:15px;"-->
<!--            v-if="lan == 'ch'"-->
<!--          >-->
<!--            2、观展时，请使用谷歌浏览器打开展会官网，如需安装，<span-->
<!--              class="download"-->
<!--              @click="download"-->
<!--            >-->
<!--              {{ language.down }}-->
<!--            </span>-->
<!--          </div>-->
<!--          <div-->
<!--            class="prompt-info"-->
<!--            v-if="lan == 'en'"-->
<!--            style="padding-top:15px;margin-top:10px;"-->
<!--          >-->
<!--            Please make sure your facilities for meeting are ready before meeting start.-->
<!--          </div>-->
<!--          <div class="prompt-info" v-if="lan == 'en'">-->
<!--            1.Your laptop or computer with camera, headset and microphone-->
<!--          </div>-->
<!--          <div-->
<!--            class="prompt-info"-->
<!--            style="padding-bottom:15px;"-->
<!--            v-if="lan == 'en'"-->
<!--          >-->
<!--            2.Using latest version of Google Chrome browser.<span-->
<!--              class="download"-->
<!--              @click="download"-->
<!--            >-->
<!--              Click to download Chrome.-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
        <!-- table -->
        <div class="table" v-for="(item,index) in orderMess" :key="index">
            <div class="table-title">
              <span class="span">下单时间：<span style="color: #666666;">{{item.order_time}}</span></span>
              <span class="span">订单号：<span style="color: #666666;">{{item.order_num}}</span></span>
            </div>
          <div class="table-content">
            <div style="flex: 2;border-right: solid 1px #cccccc;">
              <div class="left">
                <div v-if="item.order_type==3" style="width:150px;height: 90px;line-height: 90px;font-size: 16px;margin: auto;margin-left: 20px;" ref="state">
                  云钱充值
                </div>
                <div v-if="item.order_type!=3" style="color: #666666;">{{item.exh_name}}-{{ goods_exhticket_type[item.goods_exhticket_type] }}</div>
                <div v-if="item.order_type!=3">
                  <div style="width: 420px;transform: scale(0.8);margin-left: -42px;">招聘会时间：{{item.exh_begtime}} 至 {{item.exh_endtime}}</div>
                </div>
              </div>
              <div class="right" v-if="item.order_type!=3">X{{item.exhticket_count}}</div>
            </div>
            <div style="flex: 1;border-right: solid 1px #cccccc;">
              <div
                  style="color: #666666;text-align: center;" :style="item.status==1?'padding-bottom: 5px;margin: 22px auto 0;':'margin: 0 auto;transform:translateY(-50%);position: relative;top: 50%;'"
              >
                <template v-if="item.status==1">
                  <span style="color: #999999;" v-if="item.order_price == 0">0.00 元</span>
                  <span style="color: #999999;" v-if="item.pay_type==1 || item.pay_type==2 || item.pay_type==4 || item.order_type == 6 || (item.pay_type == 5 && item.crt_type == 3)">{{ item.order_price }} 元</span>
                  <!-- <span style="color: #666;" v-if="item.pay_type==3 || (item.pay_type == 5 && item.crt_type == 4)">{{ item.order_price_us }} 美元</span> -->
                  <span style="color: #999999;" v-if="item.pay_type==6 || (item.pay_type == 5 && item.crt_type == 5)">{{ item.teu_coin }} TEU COIN</span>
                </template>
                <template v-if="item.status!=1">
                  <div :style="item.status==0 ? 'color:#333333' :'color: #999999;'" v-if="item.order_type!=3">{{ item.order_price }} 元</div>
                  <div :style="item.status==0 ? 'color:#333333' :'color: #999999;'" v-if="userInfo.user_nature==3 && item.order_type!=3 && goods_exhticket_type[item.goods_exhticket_type] != '招聘会企业报名'">{{ item.teu_coin }} TEU COIN</div>
                  <div :style="item.status==0 ? 'color:#333333' :'color: #999999;'" v-if="userInfo.user_nature==3 && item.order_type==3">{{ item.goods_text }}</div>
                </template>
              </div>
              <div v-if="item.status==1" style="width: 101px;padding-bottom: 5px;border-top: solid 1px #d9d9d9;
                  color: #999;text-align: center;margin: 0px auto 0;padding-top: 6px;">
                <span v-if="item.order_price == 0">免费</span>
                <span v-if="item.pay_type==1 && item.order_type != 6">微信支付</span>
                <span v-if="item.pay_type==2 && item.order_type != 6">支付宝</span>
                <span v-if="item.pay_type==4 && item.order_type != 6">小程序</span>
                <span v-if="item.pay_type==5 && item.order_type != 6">线下</span>
                <span v-if="item.pay_type==6 && item.order_type != 6">TEU COIN</span>
              </div>
            </div>
            <div style="flex: 1;border-right: solid 1px #cccccc;">
              <div style="width:150px;height: 90px;line-height: 90px;font-size: 16px;
              color: #999999;margin: auto;text-align: center" ref="state">
                <span v-if="item.status==0" style="color: #ea4106;">等待支付</span>
                <span v-if="item.status==1">已完成</span>
                <span v-if="item.status==4">已取消</span>
              </div>
            </div>
            <div style="flex: 1.5;padding-top:34px;padding-right: 30px;text-align: right;">
               <el-button size="mini" v-if="item.status==0" style="padding: 8px 15px;background: #ea4106;width: 75px;color: #FFFFFF;padding: 8px 10px;border-radius: 5px;border: none;font-size: 16px;" @click="pay(item)">付款</el-button>
              <el-button size="mini" v-if="item.status==0" @click="cancelOrder(item)" style="padding: 8px 10px;margin-left: 20px;color: #0071ff;border: solid 1px #0071ff;font-size: 16px;">取消订单</el-button>
              <el-button size="mini" v-if="item.status==4" @click="delOrder(item)" style="padding: 8px 10px;margin-left: 30px;color: #0071ff;border: solid 1px #0071ff;font-size: 16px;">删除订单</el-button>
            </div>
          </div>
        </div>
        <!--没有订单时的状态-->
        <div v-if="dataCount == 0" style="width: 993px;margin-top: 20px;">
          <img src="../../../assets/img/wu.png" style="width: 100%;height: 100%;">
          <span style="color: #999999;font-size: 16px;position: relative;left: 421px;top: -135px;">还没有发布任何消息</span>
        </div>


        <!-- page -->
        <table-page
          :pageSize="pageSize"
          :layout="layout"
          :pageTotal="pageTotal"
          :currentPage="currentPage"
          @pageChange="pageChange"
        ></table-page>
      </div>
    </el-col>
    <el-dialog
      :visible="showShare"
      :title="language.ShareTicket"
      @update:visible="updateVisiable($event)"
      width="1000px"
      :show-close="true"
      class="hint_dialog"
    >
      <div class="share-title">{{language.Sharelinks}}</div>
      <div class="pc-url-div">
        <p id="copy_pc_url">{{shareLink}}</p>
      </div>
      <div class="url-formBtn">
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-if="lan == 'ch'"
          >复制</el-button
        >
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-else
          >Copy</el-button
        >
      </div>
      <div class="share-title">{{language.appletCode}}</div>
      <div style="padding-top:10px;">{{language.appletContent}}</div>
      <div >
        <img class="share-img" :src="shareWxQr"/>
      </div>
      <div class="url-formBtn" style="margin-top: 20px;border-bottom:0;">
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="imgDown(shareWxQr)"
         >{{language.download}}</el-button>
      </div>
    </el-dialog>

    <!--取消弹窗-->
    <el-dialog
        :visible.sync="deleteJob"
        width="300px"
        top="40vh"
        style="text-align: center;color: #313030;">
      <div style="font-size: 16px;margin-bottom: 40px;letter-spacing: 2px;">确定要{{judgeCanDel == 0 ? "取消" : "删除"}}吗？</div>
      <div>
        <el-button style="background: #0071FF;color: #FFFFFF;padding: 10px 28px !important;margin-top: 20px;"
                   @click="cancelOk">确定</el-button>
        <el-button style="background: #e4e4e4;color: #333333;padding: 10px 28px !important;margin-top: 20px;margin-left: 20px;"
                   @click="cancelNo">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {MessageBox} from 'element-ui';
import { language } from "../../../language/get";
import { ExhIndexType } from "../../../common/constant/exhibition";
import { getGzExhTicketList, ExhticketRecovery } from "../../../api/tickets";
import { ExhibitionType } from "../../../common/constant/exhibition";
import searchBar from "../components/searchbar/searchbar";
import pubTable from "../components/table/table";
import tablePage from "../components/tablepage/tablepage";
const pubLanguage = language();
import Cookies from "../../../common/cookie";
import { getBroadcastClass } from "../../../api/exhibition";
import Axios from "axios";
import reqest from "../../../common/reqest";
import {mapGetters} from "vuex";
import {searchOrder,updateOrderInfo} from "@/api/order";

export default {
  components: {
    searchBar,
    pubTable,
    tablePage,
  },
  data() {
    return {
      deleteJob:false,
      cancelObject:null, //取消订单的Id
      judgeCanDel:null, //0  取消   1 删除
      goods_exhticket_type:["门票","招聘会展位","论坛票","推荐票","增加直播间","云钱充值","招聘会企业报名","招聘会个人报名"],
      shareWxQr: '',
      shareLink: '',
      showShare: false,
      language: language(),
      dataCount:null, //订单的数量
      orderMess:[], //订单信息
      lan: Cookies.get("lang"),
      loading: true,
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索相关
      ExhIndexType,
      searchInputPlc: pubLanguage.fairName,
      searchSelectPlc: pubLanguage.state,
      //搜索条件
      getStateCon: null,
      getValCon: null,
      ExhName:'', //展会名称
      status:'', //状态
      //table 表头
      columns: [
        {
          title: pubLanguage.ticName,
          key: "exh_name",
          width: "200",
        },
        {
          title: pubLanguage.exhibitionTime,
          key: "exh_time",
          width: "300",
        },
        {
          title: pubLanguage.price,
          key: "exhticket_price",
          width: "120",
        },
        {
          title: pubLanguage.buyTime,
          key: "pay_time",
          width: "160",
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "200",
        },
      ],
      ticktsData: [],
      cloneTicktsData: [],
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    // console.log("user::::" , this.userInfo)
    this.exhTicketList();
  },
  methods: {
    delOrder(item){
      this.deleteJob = true;
      this.cancelObject = item;
      this.judgeCanDel = 1;

      // MessageBox({
      //   title: language().hint,
      //   message: "确定要删除吗",
      //   confirmButtonText: language().confirm,
      //   cancelButtonText: language().cancel,
      //   dangerouslyUseHTMLString:true,
      //   showCancelButton: true,
      //   type: 'warning'
      // }).then(() => {
      //   //确认
      //   this.updateOrder(item, 1)
      // }).catch(() => {
      //   //取消
      // });
    },
    cancelOrder(item){
        this.deleteJob = true;
        this.cancelObject = item;
        this.judgeCanDel = 0;
      // MessageBox({
      //   title: language().hint,
      //   message: "确定要取消吗",
      //   confirmButtonText: language().confirm,
      //   cancelButtonText: language().cancel,
      //   dangerouslyUseHTMLString:true,
      //   showCancelButton: true,
      //   type: 'warning'
      // }).then(() => {
      //   //确认
      //   this.updateOrder(item, 0)
      // }).catch(() => {
      //   //取消
      // });
    },
    cancelOk(){
      if(this.judgeCanDel == 0){
        this.updateOrder(this.cancelObject, 0);
      }else {
        this.updateOrder(this.cancelObject, 1);
      }
      this.deleteJob = false;
      this.judgeCanDel = null;
    },
    cancelNo() {
      this.deleteJob = false;
      this.judgeCanDel = null;
    },
    updateOrder(item, updateType){
      let prop = {
        order_id:item.order_id,
        updateType: updateType
      };
      updateOrderInfo(prop).then(res =>{
        const height = document.body.clientHeight / 2;
        this.$message({
          showClose: true,
          message: '操作成功',
          type: "success",
          offset: height
        });
        this.exhTicketList();
      })
    },
    pay(item) {
      window.location.href = item.pay_url;
      console.log("1111111111====" , item.pay_url);
    },
    imgDown(url) {
      this.downloadIamge(url, '分享二维码.png')
      //location.href = url;

    },
    // 跨域文件下载
    downloadIamge(url, fileName) {
      url = url.replace(/\\/g, "/");
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      xhr.onload = () => {
        if (xhr.status == 200) {
          let data = xhr.response;
          let name = fileName;

          var urlObject = window.URL || window.webkitURL || window;
          var export_blob = new Blob([data]);
          var save_link = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "a"
          );
          save_link.href = urlObject.createObjectURL(export_blob);
          save_link.download = name;
          save_link.click();
        }
      };

      xhr.send();
    },
    recyclingClick(item){
      let _this = this;
      MessageBox({
        title: language().hint,
        message: language().takeBackTip,
        confirmButtonText: language().confirm,
        cancelButtonText: language().cancel,
        dangerouslyUseHTMLString:true,
        showCancelButton: true,
        type: 'warning'
      }).then(() => {
        //确认
        _this.recyclingOk(item.exhticket_user_id);
      }).catch(() => {
        //取消
      });
    },
    recyclingOk(id) {
      let data = {
        token: this.$store.state.user.token,
        exhticket_user_id: id
      };
      ExhticketRecovery(data).then(res => {
        if (res.type == "1") {
          this.exhTicketList();
        } else {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
    },
    updateVisiable(e){
      this.showShare = e;
    },
    copyPcUrl() {
      let url = this.shareLink;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      const height = document.body.clientHeight / 2;
      this.$message({
        message: this.lan == 'ch'?"复制成功":"Copy succeeded",
        type: "success",
        offset:height
      });
      oInput.remove();
    },
    //复制票号
    copyNum(numData) {
      let copyData = numData.exhticketNum;
      this.copy(copyData);
    },
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      //console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      const height = document.body.clientHeight / 2;
      this.$message({
        message: this.lan == 'ch'?"复制成功":"Copy succeeded",
        type: "success",
        offset: height,
      });
      oInput.remove();
    },
    //搜索切换
    toSearch(val) {
      if(val){
        this.ExhName = val.name;
        this.status = val.status;
      }
      this.currentPage = 1;
      this.exhTicketList();
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.exhTicketList();
    },
    //展会门票列表
    exhTicketList() {
      let that = this;
      let data = {
        token: this.$store.state.user.token,
        exh_name: this.ExhName,
        lan: this.lan,
        status:this.status,
        user_id: this.userInfo.user_id,
        currentPage: this.currentPage,
        numberPage: this.pageSize,
      };
      searchOrder(data).then((res)=>{
        if(res.type !="1"){
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }else{
            this.orderMess = res.data.list;
            this.pageTotal = parseInt(res.data.count);
            this.dataCount = res.datacount;
            // console.log("订单数量== " + this.dataCount);
        }
      });
      // getGzExhTicketList(data).then((res) => {
      //   if (res.type != "1") {
      //     if (this.lan == "ch") {
      //       return this.$message.error({ message: res.text, offset: 120 });
      //     }
      //     return this.$message.error({ message: res.text_en, offset: 120 });
      //   }
      //   if (!res.data) {
      //     this.ticktsData = [];
      //     this.cloneTicktsData = [];
      //     this.pageTotal = 0;
      //     this.loading = false;
      //     return;
      //   }
      //   res.data.forEach((item) => {
      //     if (this.lan == "en") {
      //       item.exh_name = `${item.exh_name_en}`;
      //       item.exh_begtime = `${item.exh_begtime_en}`;
      //       item.exh_endtime = `${item.exh_endtime_en}`;
      //       item.pay_time = `${item.pay_time_en}`;
      //     }
      //     item.exh_time = `${item.exh_begtime} ${this.language.to} ${item.exh_endtime}`;
      //     item.exhticket_price = `${item.exhticket_price}${this.language.CNY}/${this.language.site1}`;
      //   });
      //   this.ticktsData = res.data;
      //   this.cloneTicktsData = res.data;
      //   this.pageTotal = Number(res.datacount);
      //   this.loading = false;
      // });
    },
    //下载谷歌浏览器
    download() {
      window.open(
        "https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds"
      );
    },
    shareClick(data){
      let encodeData = window.btoa(window.encodeURIComponent("exhticket_user_id="+data.dataList.exhticket_user_id));
      this.showShare = true;
      let nowUrl = location.href.substring(0, location.href.lastIndexOf('.html'));
      nowUrl = nowUrl.substring(0, nowUrl.lastIndexOf('/'));
      this.shareLink = nowUrl+"/shareExhticket.html?"+encodeData;
      this.shareWxQr = reqest.adminapi+'MakeQr/getShareTicketQr?exhticket_user_id='+data.dataList.exhticket_user_id;
    },
    getJoin(data) {
      window.location.href =
        "forum.html" + "?exhibition_id=" + data.dataList.exhibition_id;
    },
  },
};
</script>

<style scoped>
.table {
  width: 993px;
  min-height: 151px;
  background-color: #ffffff;
  border-radius: 5px;
  margin-top: 20px;
  /*padding: 17px 18px 16px 18px;*/
  padding-top: 17px;
  padding-bottom: 10px;
}
.table-title{
  width: 960px;
  height: 40px;
  background-color: #f6f9ff;
  border: solid 1px #cccccc;
  margin:5px 18px 0 18px;
}
.table-title .span {
  margin-left: 20px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #999999;
}
.table-title .span:last-child{
  margin-left: 80px;
}
.table-content {
  width: 960px;
  min-height: 95px;
  display: flex;
  background-color: #ffffff;
  border: solid 1px #cccccc;
  margin-left: 18px;
  margin-bottom: 16px;
  border-top: 0px;
}
.table-content .left {
  float: left;
  color: #666666;
  font-size: 16px;
}
.table-content .left div:first-child{
  width: 250px;
  /*height: 24px;*/
  font-family: SourceHanSansCN-Bold;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
  margin-left: 20px;
  margin-top: 20px;
  overflow: hidden;
}
.table-content .left div:last-child {
  width: 260px;
  height: 20px;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
  margin-left: 20px;
  margin-top: 10px;
}
.table-content .right {
  float: right;
  height: 90px;
  line-height: 90px;
  font-size: 14px;
  color: #999999;
  margin-right: 20px;
}
.exhibitionRecord >>> .tableNode {
  padding: 30px 20px;
  border-radius: 5px;
}
.prompt-info-wrap {
  background: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  margin-top: 10px;
}
.prompt-info {
  height: 30px;
  line-height: 30px;
  background: #fff;
  padding-left: 15px;
  color: #ed6c00;
  font-size: 16px;
  font-weight: bold;
}
.prompt-info span {
  color: #0f408a;
  cursor: pointer;
}
.exhibitionRecord >>> .infoPub .tableNode {
  border-radius: 5px;
  height: 180px;
  margin-bottom: 10px;
}

.pc-url-div {
  margin: 30px auto;
  width: 800px;
  height: 80px;
  line-height: 80px;
  border-radius: 10px;
  background: #ececec;
  color: #000;
  display: block;
  padding: 0px 50px;
  /* margin: 0 auto; */
}
.share-title{
  padding: 0px 10px;
  font-weight:bold;
  border-left: 5px solid #0c6dce;
  font-size:18px;
}
.share-img{
  display: block;
  height: 150px;
  width: auto;
  margin: 0px auto;
}

.url-formBtn{
  border-bottom:1px solid #eee;
  padding-bottom:20px;
  margin-bottom:10px;
}
.page {
  margin-left: 0px;
}

</style>
